import { render, staticRenderFns } from "./ToolPointList.vue?vue&type=template&id=0821dca6&scoped=true"
import script from "./ToolPointList.vue?vue&type=script&lang=js"
export * from "./ToolPointList.vue?vue&type=script&lang=js"
import style0 from "./ToolPointList.vue?vue&type=style&index=0&id=0821dca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0821dca6",
  null
  
)

export default component.exports